// 商品詳細の作家情報モーダル
document.addEventListener('DOMContentLoaded', function() {
  const productDescription = document.querySelector('.product__description');

  if (!productDescription) return;

  let modal = document.getElementById('AuthorInfoModal');

  if (!modal) {
    document.body.insertAdjacentHTML(
      'beforeend',
      `<modal-dialog id="AuthorInfoModal" class="author-info-modal">
        <div
          role="dialog"
          aria-label="作家情報"
          aria-modal="true"
          class="author-info-modal__content"
          tabindex="-1"
        >
          <button
            type="button"
            class="author-info-modal__toggle"
            id="ModalClose-author-info"
            aria-label="閉じる"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="author-info-modal__content-info">
            <h2 class="h2 author-info-modal__title">作家情報</h2>
            <div class="author-info-modal__body rte"></div>
          </div>
        </div>
      </modal-dialog>`
    );
    modal = document.getElementById('AuthorInfoModal');
  }

  const modalBody = modal.querySelector('.author-info-modal__body');

  productDescription.querySelectorAll('dl a').forEach(function(link) {
    link.addEventListener('click', function(e) {
      const currentDl = link.closest('dl');
      let nextDl = currentDl.nextElementSibling;

      while (nextDl) {
        if (nextDl.tagName === 'DL' && nextDl.classList.contains('open')) {
          e.preventDefault();

          const content = nextDl.querySelector('dd');
          if (content && modalBody) {
            modalBody.innerHTML = content.innerHTML;
          }

          modal.show(link);
          break;
        }

        nextDl = nextDl.nextElementSibling;
      }
    });
  });
});
